<template>
  <section class="color-new-light-grey">
    <v-container :class="{ 'pa-0' : this.$vuetify.breakpoint.smAndDown }">
      <v-row justify="center" :class="{ 'ma-0' : this.$vuetify.breakpoint.smAndDown }">
        <v-col cols="12">
          <h1 class="text-center mb-0" :class="{ 'text-h3': this.$vuetify.breakpoint.smAndDown, 'text-h1': this.$vuetify.breakpoint.mdAndUp }">{{ $t('helpPageHeader') }}</h1>
        </v-col>
        <v-col cols="12" sm="8" :class="{ 'text-center' : this.$vuetify.breakpoint.mdAndUp }">
          <p :class="{ 'mb-0' : this.$vuetify.breakpoint.mdAndUp }">{{ $t('helpPageText1') }}</p>
          <p :class="{ 'mb-5' : this.$vuetify.breakpoint.mdAndUp }">{{ $t('helpPageText2') }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="tab"
                  centered
                  icons-and-text
                  background-color="transparent"
                  slider-color="color-new-link-blue"
                  slider-size="4"
                  :class="{ 'radius-tabs' : this.$vuetify.breakpoint.mdAndUp }" height="64px" @change="tabPageEvent">
            <v-tab href="#Faq">
              {{ $t('helpPageFaq') }}
              <v-icon>fas fa-question-circle</v-icon>
            </v-tab>
            <v-tab href="#CustomerSupport">
              {{ $t('helpPageCs') }}
              <v-icon>fas fa-comments</v-icon>
            </v-tab>
            <v-tab href="#Links">
              {{ $t('helpPageLinks') }}
              <v-icon>fas fa-link</v-icon>
            </v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item value="Faq">
                <v-card :class="{ 'radius-card' : this.$vuetify.breakpoint.mdAndUp }">
                  <v-container fluid :class="{ 'pa-5 ' : this.$vuetify.breakpoint.mdAndUp, 'pa-3': this.$vuetify.breakpoint.smAndDown }">
                    <v-row justify="center" class="mt-6">
                      <v-col cols="10" sm="6">
                        <v-text-field append-icon="fas fa-search"
                                      :label="$t('writeSearchString')"
                                      v-model="searchQueryString"
                                      class="search-field">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="12" sm="9" v-if="faqs.length === 0 && searchQueryString.length > 2">
                        <v-row justify="center">
                          <span>{{ $t('faqSearchNotFound') }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" lg="9" v-if="faqs.length > 0">
                        <div class="mb-9" v-for="(category, index) in categories" :key="index" v-if="category.length">
                          <h4 class="text-h4 mt-0">{{ $t('category.' + index) }}</h4>
                          <v-expansion-panels focusable hover multiple>
                            <v-expansion-panel v-for="item in category" :key="item.questionNr">
                              <v-expansion-panel-header>
                                {{ item.question }}
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <div v-html="item.answer"></div>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <div class="pa-3">
                        <v-btn tile outlined color="color-new-link-blue" @click="tab = 'CustomerSupport'">{{ $t('takeCCcontact') }}</v-btn>
                      </div>
                    </v-row>
                  </v-container>
                </v-card>
              </v-tab-item>
              <v-tab-item value="CustomerSupport">
                <v-card :class="{ 'radius-card' : this.$vuetify.breakpoint.mdAndUp }">
                  <v-container :class="{ 'pa-5 ' : this.$vuetify.breakpoint.mdAndUp, 'pa-3': this.$vuetify.breakpoint.smAndDown }">
                    <v-row justify="center">
                      <v-col cols="12" md="9">
                        <v-row justify="center">
                          <v-col cols="12" sm="9">
                            <p>{{ $t('okAdviceText') }}</p>
                          </v-col>
                        </v-row>
                        <v-row justify="center">
                          <v-col cols="12" sm="6" md="5">
                            <v-row justify="center">
                              <v-col cols="12">
                                <v-img src="/static/images/omaok-service.png" />
                              </v-col>
                            </v-row>
                            <v-row justify="center">
                              <v-col cols="12">
                                <h4 class="text-center mt-0 text-h4">{{ $t('customerSupport') }}</h4>
                                <p class="text-center">{{ $t('customerSupportText') }}</p>
                                <p class="ok-subtitle big primary--text text-center mb-0" v-if="!showCompanyNumber">{{ customerServiceNumber }}</p>
                                <p class="text-caption text-center" v-if="!showCompanyNumber">{{ $t('customerServicePhoneFee') }}</p>
                                <p class="ok-subtitle big primary--text text-center mb-0" v-if="showCompanyNumber">{{ companyServiceNumber }}</p>
                                <p class="text-caption text-center" v-if="showCompanyNumber">{{ $t('companyServicePhoneFee') }}</p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-tab-item>
              <v-tab-item value="Links">
                <v-card :class="{ 'radius-card' : this.$vuetify.breakpoint.mdAndUp }">
                  <v-container fluid :class="{ 'pa-5 ' : this.$vuetify.breakpoint.mdAndUp, 'pa-3': this.$vuetify.breakpoint.smAndDown }">
                    <v-row no-gutters justify="center">
                      <h3 class="mt-0 text-h3">{{ $t('linkAndMoreInfo') }}</h3>
                    </v-row>
                    <v-row no-gutters justify="center">
                      <p>{{ $t('LinksAndMoreInfoHeader') }}</p>
                    </v-row>
                    <v-row no-gutters justify="center">
                      <v-col cols="12" sm="6" md="5">
                        <h5 class="text-h5">{{ $t('consumerFinance') }}</h5>
                        <a target="_blank" class="linkStyles" href="https://www.kkv.fi">{{ $t('competetionAndConsumerAuth') }}</a>
                        <br />
                        <a target="_blank" class="linkStyles" href="https://www.kkv.fi/Tietoa-ja-ohjeita/Maksut-laskut-perinta/talouden-suunnittelu/">{{ $t('financialMgmnt') }}</a><br />
                        <a target="_blank" class="linkStyles" href="https://www.kkv.fi/Tietoa-ja-ohjeita/Maksut-laskut-perinta/perinta/">{{ $t('delayedPayment') }}</a> <br />
                        <a target="_blank" class="linkStyles" href="https://www.kkv.fi/Tietoa-ja-ohjeita/Maksut-laskut-perinta/luotot">{{ $t('faqCredit') }}</a><br />
                        <a target="_blank" class="linkStyles" href="https://www.kkv.fi/Tietoa-ja-ohjeita/Maksut-laskut-perinta/talous--ja-velkaneuvojat/">{{ $t('debtAdvisors') }}</a><br />
                        <h5 class="text-h5">{{ $t('guranteeFoundation') }}</h5>
                        <br />
                        <a target="_blank" class="linkStyles" href="https://www.takuusaatio.fi/">{{ $t('informationAssistance') }}</a>
                        <br />
                        <h5 class="text-h5">Penno</h5>
                        <a target="_blank" class="linkStyles" href="https://penno.fi/home">{{ $t('faqBudget') }}</a> <br />
                        <h5 class="text-h5">Suomen Asiakastieto Oy</h5>
                        <a target="_blank" class="linkStyles" href="https://www.asiakastieto.fi/omatieto/fi/ukk">{{ $t('faqSat') }}</a>
                        <br />
                        <h5 class="text-h5">{{ $t('faqUlosotto') }}</h5>
                        <a target="_blank" class="linkStyles" href="https://ulosottolaitos.fi/fi/">{{ $t('moreInfoUlosotto') }}</a>
                        <br />
                        <h5 class="text-h5">{{ $t('districtCourt') }}</h5>
                        <a target="_blank" class="linkStyles" href="https://oikeus.fi/tuomioistuimet/fi/index.html">{{ $t('moreInfoCourt') }} </a>
                        <h5 class="text-h5">{{ $t('victimSupport') }}</h5>
                        <a target="_blank" class="linkStyles" href="https://www.riku.fi/fi/etusivu">{{ $t('vsInfo') }}</a>
                        <br />
                        <a target="_blank" class="linkStyles" href="https://poliisi.fi/tee-rikosilmoitus">{{ $t('offenseReport') }}</a>
                        <br />
                      </v-col>
                      <v-col cols="12" sm="6" md="5">
                        <h5 class="text-h5">{{ $t('forCompanies') }}</h5>
                        <h5 class="text-h5">{{ $t('companyFinland') }}</h5><br />
                        <a target="_blank" class="linkStyles" href="https://oma.yrityssuomi.fi/">{{ $t('companyGuide') }}</a><br />
                        <h5 class="text-h5">{{ $t('finnishCompFed') }}</h5><br />
                        <a target="_blank" class="linkStyles" href="https://www.yrittajat.fi/yrittajan-abc/taloushallinto-ja-maksut-316150">{{ $t('enterpriseMoreInfo') }}</a> <br />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: function () {
      return {
        tab: null,
        searchQueryString: '',
        faqs: [],
        allFaqs: [],
        customerServiceNumber: '030 10 5620',
        companyServiceNumber: '030 603 5800'
      }
    },
    watch: {
      locale: function (val) {
        this.handleSearch(this.searchQueryString)
      },
      searchQueryString: function (value, oldValue) {
        this.handleSearch(value)
      }
    },
    methods: {
      handleSearch: function (value) {
        this.faqs = []
        let words = value.trim().split(' ')
        if (value.length > 2) {
          words.forEach((word) => {
            if (this.faqs.length === 0) {
              var val = this.filterFaq(this.langFilteredFAQ, word)
              if (val.length > 0) {
                val.forEach((v) => {
                  this.faqs.push(v)
                })
              }
            } else {
              this.faqs = this.filterFaq(this.langFilteredFAQ, word)
            }
          })
        } else {
          this.faqs = this.langFilteredFAQ
        }
      },
      filterFaq: function (faqObj, value) {
        var regexp = new RegExp(value, 'i')
        var val = faqObj.filter(function (item) {
          return (item.answer + ' ' + item.keyword + ' ' + item.category + ' ' + item.question).match(regexp)
        })
        return val
      }
    },
    computed: {
      ...mapGetters({
        locale: 'locale',
        debtor: 'debtor'
      }),
      showCompanyNumber () {
        if (this.debtor !== null && this.debtor.isCompany) {
          return true
        } else {
          return false
        }
      },
      lang () {
        if (this.locale === 'fi') {
          return 1
        } else if (this.locale === 'se') {
          return 2
        } else if (this.locale === 'en') {
          return 3
        } else {
          return null
        }
      },
      langFilteredFAQ () {
        return this.allFaqs.filter(f => f.langCode === this.lang)
      },
      categories () {
        var common = this.faqs.filter(f => f.category === 'Yleistä')
        var credit = this.faqs.filter(f => f.category === 'Luottotiedot')
        var costs = this.faqs.filter(f => f.category === 'Perinnän kulut')
        var procedure = this.faqs.filter(f => f.category === 'Perinnän eteneminen')
        return { 'common': common, 'credit': credit, 'costs': costs, 'procedure': procedure }
      }
    },
    created: function () {
      if (this.$route.hash === '#CustomerSupport') {
        this.tab = 'CustomerSupport'
      }

      this.$store.dispatch('getFaqData').then(response => {
        this.allFaqs = response
        this.faqs = this.langFilteredFAQ
      }, error => {
        console.log('data not found from getFaqData' + error.stack)
      })
    }
  }
</script>

<style>
  a.linkStyles {
    color: #3EB1C8;
    text-decoration: none;
  }
  a.linkStyles:hover {
    text-decoration:underline;
  }
  .radius-tabs > .v-tabs-bar {
    border-radius: 8px 8px 0 0;
  }
  .search-field label {
    font-size: 20px;
  }
  .v-expansion-panel-content div.v-expansion-panel-content__wrap {
    padding-top: 16px;
  }

  @media (max-width: 768px) {
    .v-expansion-panel__header {
      height: auto;
      padding: 8px;
    }

    .v-expansion-panel--popout .v-expansion-panel__container, .v-expansion-panel--inset .v-expansion-panel__container {
      max-width: 100%;
    }
  }
</style>

<i18n>
  {
  "fi": {
  "helpPageHeader": "Oma B2 Impact tukisivut",
  "helpPageText1": "Tähän osioon olemme koonneet tietoa, ohjeita ja apua velka-asioittesi hoitoon.",
  "helpPageText2": "Mikäli et löydä vastausta kysymykseesi, asiakaspalvelumme auttaa sinua eteenpäin.",
  "helpPageFaq": "USEIN KYSYTTYÄ",
  "helpPageCs": "ASIAKASPALVELU",
  "helpPageLinks": "LINKKEJÄ",
  "faqSectionHeader": "Usein kysyttyjä kysymyksiä & vastauksia",
  "writeSearchString": "Kirjoita hakusana...",
  "faqSearchNotFound": "Etkö löytänyt vastausta kysymykseesi? Asiakaspalvelumme auttaa sinua.",
  "category": {
  "common": "Yleistä",
  "credit": "Luottotiedot",
  "costs": "Perinnän kulut",
  "procedure": "Perinnän eteneminen"
  },
  "okAdvice": "Asiakaspalvelu",
  "okAdviceText": "Asiakaspalvelun kautta tavoitat palveluneuvojamme ja voit keskustella henkilökohtaisesti sopivasta tavasta velan hoitamiseksi, jotta pystyt välttämään mahdollisen maksuhäiriömerkinnän. Meille perintä on ennen kaikkea ratkaisujen etsimistä.",
  "customerSupport": "Asiakaspalvelu",
  "customerSupportText": "Paveluneuvojamme auttavat sinua ma-to 8-18 ja pe 8-17.",
  "onlineChat": "Online Chat",
  "onlineChatText": "Oma B2 Impact -verkkopalvelun chat on avoinna arkisin klo 8-16.",
  "callBack": "Soittopyyntö",
  "callBackText": "Lähetä nimesi ja asianumerosi tekstiviestitse numeroon:",
  "takeCCcontact": "Ota Yhteyttä asiakaspalveluumme",
  "faqSendMessage": "Sähköposti",
  "linkAndMoreInfo": "Linkkejä ja lisätietoja",
  "LinksAndMoreInfoHeader": "Tältä sivulta löydät tietoa ja tukea velanhoitoon liittyviin asioihin",
  "SendEmailMessage": "Pyrimme vastaamaan viesteihin mahdollisimman nopeasti. Muistathan mainita myös asianumeron.",
  "consumerFinance": "Kuluttajan talous",
  "competetionAndConsumerAuth": "Kilpailu- ja kuluttajavirasto",
  "financialMgmnt": "Talouden suunnittelu",
  "delayedPayment": "Maksuviivästykset ja perintä",
  "faqCredit": "Luotot",
  "debtAdvisors": "Talous ja velkaneuvojat",
  "guranteeFoundation": "Takuusäätiö",
  "informationAssistance": "Tietoa ja neuvontaa oman talouden hallinnalle",
  "faqBudget": "Takuusäätiön verkkopalvelu jossa voit seurata kuukausittain omia tulojasi sekä säästötavoitteesi toteutumista",
  "faqSat": "Luottotietomerkinnöistä ja omien luottotietojen kysymisestä",
  "faqUlosotto": "Ulosotto",
  "moreInfoUlosotto": "Lisää tietoa ulosotosta",
  "districtCourt": "Käräjäoikeus",
  "moreInfoCourt": "Lisää tietoa käräjäoikeudesta",
  "victimSupport": "Rikosilmoitus",
  "vsInfo": "Rikosuhripäivystys",
  "offenseReport": "Rikosilmoitus",
  "forCompanies": "Yrityksille",
  "companyFinland": "Yritys-Suomi",
  "companyGuide": "Yritysneuvontapalvelua",
  "finnishCompFed": "Suomen Yrittäjät",
  "enterpriseMoreInfo": "Yrittäjän ABC - Taloushallinto ja maksut",
  "customerServicePhoneFee": "(mpm/pvm)",
  "companyServicePhoneFee": "(mpm/pvm)"
  },
  "se": {
  "helpPageHeader": "Min B2 Impact hjälpsidor",
  "helpPageText1": "Här har vi samlat information som stöd för din hantering av dina skulder.",
  "helpPageText2": "Om du inte hittar den information du söker, hjälper vår kundtjänst dig gärna vidare.",
  "helpPageFaq": "Frågor & svar",
  "helpPageCs": "Kundtjänst",
  "helpPageLinks": "Länkar",
  "faqSectionHeader": "Här hittar du svaren på de vanligaste frågorna",
  "writeSearchString": "Sök",
  "faqSearchNotFound": "Om du inte hittade svaret på din fråga, hjälper vår kundtjänst dig gärna vidare.",
  "category": {
  "common": "Generella frågor",
  "credit": "Kreditinformation",
  "costs": "Inkassokostnader",
  "procedure": "Inkassoprosessen"
  },
  "okAdvice": "Kundtjänst",
  "okAdviceText": "Via kundtjänst når du våra servicerådgivare och kan diskutera en betalningslösning som passar dig bäst. På så sätt kan du undvika en eventuell betalningsanmärkning. För oss betyder inkasso framför allt att hitta lösningar på problemen.",
  "customerSupport": "Kundtjänst",
  "customerSupportText": "Våra servicerådgivare är på plats och hjälper dig må-to 8 -18 och fre 8-17.",
  "onlineChat": "Online Chat",
  "onlineChatText": "Chatten på Min B2 Impact är öppen vardagar kl 8-16",
  "callBack": "Uppringningstjänst",
  "callBackText": "Skicka ditt namn och ärendenummer som SMS till: ",
  "takeCCcontact": "Ta kontakt med vår kundtjänst",
  "faqSendMessage": "E-post",
  "linkAndMoreInfo": "Linkkejä and lisätietoja",
  "LinksAndMoreInfoHeader": "Här hittar du information och stöd för hanteringen av dina skulder",
  "SendEmailMessage": "Vi strävar efter att svara så snabbt som möjligt. Kom ihåg att nämna ditt ärendenummer.",
  "consumerFinance": "Konsumentens Ekonomi",
  "competetionAndConsumerAuth": "Konkurrens-och konsumentverket",
  "financialMgmnt": "Ekonomiplanering",
  "delayedPayment": "Betalningsdröjsmål och indrivning",
  "faqCredit": "Krediter",
  "debtAdvisors": "Ekonomi och skuldrådgivare",
  "guranteeFoundation": "Garantistiftelsen",
  "informationAssistance": "Information och rådgivning om hjälp inom ekonomisk krishantering",
  "faqBudget": "Få en överblick över din ekonomi med hjälp av garantistiftelsens applikation Penno",
  "faqSat": "Allmänn kreditinformation",
  "faqUlosotto": "Utsökning",
  "moreInfoUlosotto": "Information om utsökningen",
  "districtCourt": "Tingsrätten",
  "moreInfoCourt": "Mer information om tingsrätten",
  "victimSupport": "Brottsofferjouren",
  "vsInfo": "Information om brottsofferjouren",
  "offenseReport": "Elektronisk brottsamälan",
  "forCompanies": "För företag",
  "companyFinland": "Företagsfinland",
  "companyGuide": "Rådgivning för företagare",
  "finnishCompFed": "Företagarna i Finland",
  "enterpriseMoreInfo": "Företagarens ABC",
  "customerServicePhoneFee": "(msa/lna)",
  "companyServicePhoneFee": "(msa/lna)"
  },
  "en": {
  "helpPageHeader": "My B2 Impact - Support",
  "helpPageText1": "On this page we have collected information to support you in managing your debts.",
  "helpPageText2": "If you do not find the information you need, our customer service is happy to assist you.",
  "helpPageFaq": "Faq",
  "helpPageCs": "Support",
  "helpPageLinks": "Links",
  "faqSectionHeader": "Frequently asked questions and answers",
  "writeSearchString": "Search",
  "faqSearchNotFound": "If you did not find the answer to your question, our customer service is happy to help you.",
  "category": {
  "common": "General",
  "credit": "Credit information",
  "costs": "Collection Fees",
  "procedure": "Collection process"
  },
  "okAdvice": "Customer Support",
  "okAdviceText": "Contact support to reach our service advisers that can discuss payment solutions that suit you the best. For us, collection means finding solutions to problems.",
  "customerSupport": "Customer Support",
  "customerSupportText": "Our service advisors help you mo-thu 8-18 and fri 8-17.",
  "onlineChat": "Online Chat",
  "onlineChatText": "The chat on My B2 Impact is open during weekdays 8-16.",
  "callBack": "Callback",
  "callBackText": "Send your name and case number via text message to the number:",
  "takeCCcontact": "Contact us",
  "faqSendMessage": "E-mail",
  "linkAndMoreInfo": "Links and more info",
  "LinksAndMoreInfoHeader": "Here you can find information and support for the management of your debts",
  "SendEmailMessage": "We aim to answer your message as quickly as possible. Please remember to mention your case number.",
  "consumerFinance": "Consumer Finance",
  "competetionAndConsumerAuth": "Competition and consumer authority",
  "financialMgmnt": "Financial management",
  "delayedPayment": "Delayed payment and collection",
  "faqCredit": "Credit",
  "debtAdvisors": "Financial and debt advisers",
  "guranteeFoundation": "Guarantee Foundation",
  "informationAssistance": "Information on assistance in struggling with personal finance issues",
  "faqBudget": "A web service that helps to keep you on budget ",
  "faqSat": "Credit information (in Finnish)",
  "faqUlosotto": "Enforcement",
  "moreInfoUlosotto": "More information on enforcement",
  "districtCourt": "District Courts",
  "moreInfoCourt": "More information on district courts",
  "victimSupport": "Victim Support Finland",
  "vsInfo": "Victim Support information",
  "offenseReport": "Reporting an offence online",
  "forCompanies": "For companies",
  "companyFinland": "Company-Finland",
  "companyGuide": "Service and guidance for companies in Finland (in Finnish)",
  "finnishCompFed": "The federation of Finnish Enterprises",
  "enterpriseMoreInfo": "More information for enterprises in Finland",
  "customerServicePhoneFee": "(mobile call charge / local network charge)",
  "companyServicePhoneFee": "(mobile call charge / local network charge)"
  }
  }
</i18n>
